//
//
//
//
//
//

export default {
  name: "app",
  data() {
    return {
      themeClass: "theme-yellow" // 默认主题金黄色
    };
  },
  created() {
    // 主题设置，一下主题的设置代码不能放到mounted中，因为访问路由的组件会先于此组件渲染
    this.initTheme();
  },
  methods: {
    initTheme() {
      let theme = localStorage.getItem("JYDB_THEME");
      // 如果有主题缓存，并且主题为黑色，设置黑色主题，否则，设置为默认主题黄色
      let root = document.querySelector(":root");
      if (theme && theme == "black") {
        this.$root.themeType = "black";
        root.style.setProperty("--color", "#facd89");
        this.themeClass = "theme-black";
        document.documentElement.style.backgroundColor = "#242626";
      } else {
        this.$root.themeType = "yellow";
        root.style.setProperty("--color", "#fc581f");
        this.themeClass = "theme-yellow";
        document.documentElement.style.backgroundColor = "#fff";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue